import $ from "jquery";

/**
 * Модуль отвечает за отображение выпадающего меню
 * при клике на аватарку пользователя
 */

function initAvatarCabinet() {
  const avatarControlButtons = $(".avatar-control-button");
  const avatarControl = $("#avatar-control");
  const overlay = $("#notification-overlay");
  const avatarControlClose = $(".avatar-cabinet__close");

  // дополнительные проверки
  if (avatarControlButtons.length === 0 || avatarControl.length === 0) {
    console.info("Avatar control button or avatar control not found.");
    return;
  }

  // на мобилке вкладываем менюшку в оверлей
  if (window.innerWidth <= 768) {
    overlay.append(avatarControl);
    avatarControlClose.removeClass("hidden");

    avatarControlClose.on("click", () => {
      overlay.fadeOut();
      avatarControl.addClass("hidden");
    });
  }

  let isAvatarControlOpen = false;

  avatarControlButtons.on("click", () => {
    if (!isAvatarControlOpen) {
      overlay.fadeIn();
      overlay.css("display", "flex");
      avatarControl.removeClass("hidden");
    } else {
      overlay.fadeOut();
      overlay.css("display", "none");
      avatarControl.addClass("hidden");
    }
    isAvatarControlOpen = !isAvatarControlOpen;
  });

  overlay.on("click", () => {
    if (isAvatarControlOpen) {
      overlay.fadeOut();
      overlay.css("display", "none");
      avatarControl.addClass("hidden");
      isAvatarControlOpen = false;
    }
  });
  // Закрываем меню при нажатии клавиши Esc
  $(document).on("keydown", (event) => {
    if (isAvatarControlOpen && event.key === "Escape") {
      overlay.fadeOut();
      overlay.css("display", "none");
      avatarControl.addClass("hidden");
      isAvatarControlOpen = false;
    }
  });
}

export default function () {
  initAvatarCabinet();
}
